
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaExclamationTriangle,
  FaClock,
  FaShieldAlt,
  FaTimes,
  FaCheckCircle,
} from "react-icons/fa";

const WithdrawalNoticeModal = ({ onClose }) => {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 15 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 15 }}
          className="relative w-full max-w-sm rounded-xl border border-yellow-500/30 bg-[#0b1424] shadow-2xl"
        >
          <div className="h-1 rounded-t-xl bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" />

          <button
            onClick={onClose}
            className="absolute right-3 top-3 rounded-full p-1.5 text-gray-400 hover:bg-white/10"
            aria-label="Close"
          >
            <FaTimes size={14} />
          </button>

          <div className="px-5 py-5 text-center">

            <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full border border-yellow-500/30 bg-yellow-500/10">
              <FaExclamationTriangle className="text-xl text-yellow-400" />
            </div>

            <span className="rounded-full border border-yellow-500/30 bg-yellow-500/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-yellow-400">
              Important Notice
            </span>

            <h2 className="mt-3 text-lg font-bold text-white">
              Withdrawal Processing Update
            </h2>

               <p className="text-sm leading-relaxed text-gray-300">
  Due to a temporary technical issue with Binance, today's withdrawal
  processing has been delayed. We have taken this precaution to ensure
  your payment is processed safely and does not get lost or stuck during
  the transaction.
</p> 

        <div className="mt-4 rounded-lg border border-yellow-500/20 bg-yellow-500/5 p-3">
  <p className="text-xs font-semibold uppercase tracking-wider text-yellow-400">
    Next Withdrawal Date
  </p>
  <p className="mt-1 text-2xl font-bold text-white">15th</p>
  <p className="mt-1 text-xs text-gray-400">
    Withdrawals will resume on the 15th as per the usual schedule.
  </p>
</div>

            {/* <div className="mt-3 flex items-start gap-2 rounded-lg bg-white/[0.04] p-3 text-left">
              <FaShieldAlt className="mt-0.5 shrink-0 text-green-400" size={13} />
           <p className="mt-3 text-xs text-gray-400">
  Your funds remain secure. We appreciate your patience and understanding.
</p>
            </div> */}

            <p className="mt-3 text-[11px] text-gray-400">
              Thank you for your patience and understanding.
            </p>

            <button
              onClick={onClose}
              className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-yellow-500 to-yellow-400 py-2.5 text-sm font-bold text-[#101827] transition hover:brightness-110 active:scale-[0.98]"
            >
              <FaCheckCircle size={13} />
              I Understand
            </button>

            <p className="mt-3 text-[10px] text-gray-600">
              3Workers · Smart Investing. Pure Transparency.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default WithdrawalNoticeModal;
